import type { ImageAspectRatio } from '@/types/flow';

/**
 * Detecta o aspect ratio mais próximo das dimensões da imagem.
 * - >= 1.5 → horizontal (1.91:1)
 * - senão  → square (1:1)
 */
export const detectAspectFromDimensions = (
    width: number,
    height: number,
): ImageAspectRatio => {
    if (!width || !height || height <= 0) return 'horizontal';
    const ratio = width / height;
    return ratio >= 1.5 ? 'horizontal' : 'square';
};

/**
 * Lê dimensões de uma imagem (URL ou data URL) e devolve o aspect detectado.
 * Retorna `'horizontal'` como fallback em caso de erro.
 */
export const detectAspectFromUrl = (url: string): Promise<ImageAspectRatio> =>
    new Promise((resolve) => {
        if (!url) return resolve('horizontal');
        const img = new Image();
        img.onload = () => resolve(detectAspectFromDimensions(img.naturalWidth, img.naturalHeight));
        img.onerror = () => resolve('horizontal');
        img.src = url;
    });

/**
 * Classe Tailwind correspondente ao aspect — usar em divs/imgs de preview.
 * undefined cai pra 'square' (legacy).
 */
export const aspectClass = (aspect?: ImageAspectRatio): string => {
    return aspect === 'horizontal' ? 'aspect-[1.91/1]' : 'aspect-square';
};

/**
 * Label humanizada pra UI.
 */
export const aspectLabel = (aspect?: ImageAspectRatio): string => {
    return aspect === 'horizontal' ? 'Horizontal (1.91:1)' : 'Quadrado (1:1)';
};
